import './CircularMeter.css';

const CircularMeter = ({ value }) => {
  const radius = 50;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (value / 100) * circumference;

  return (
    <div className="progress-container">
    <svg className="progress-circle" width="120" height="120">
      <defs>
        <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#AA367C" />
          <stop offset="100%" stopColor="#4A2FBD" />
        </linearGradient>
        <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow dx="0" dy="2" stdDeviation="2" floodColor="#000" floodOpacity="0.3" />
        </filter>
      </defs>
      <circle className="progress-bg" cx="60" cy="60" r={radius} />
      <circle
        className="progress"
        cx="60"
        cy="60"
        r={radius}
        stroke="url(#gradient)"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        filter="url(#shadow)"
      />
    </svg>
    <div className="progress-value">{value}%</div>
  </div>
  );
};

export default CircularMeter;
